module.exports = {"id":"189506","name":"Victor Sánchez","rating":"78","photo":"./data/images/photos/4/189506.png","club":{"name":"Esp. Barcelone","logo":"./data/images/clubs/Esp.Barcelone.png"},"positions":["DD","MDC","MC","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VictorSanchez0.json
// module id = 4258
// module chunks = 0